import React from 'react';
import './styles.css';

function Footer() {
  return (
    <footer className="footer scroll-reveal">
      <div className="footer-top">
          <div className="footer-main">
            <div className="footer-eyebrow">Contact us</div>
            <h2>Let's Discuss Your Vision. With Us</h2>
            <a className="footer-cta" href="/#contact">
              Schedule a call now <span aria-hidden="true">→</span>
            </a>
            <div className="footer-email">
              <div className="footer-email-label">Or email us at</div>
              <a className="footer-email-pill" href="mailto:mdfaizan@frfisheries.com">
              mdfaizan@frfisheries.com
              <span className="footer-copy-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="img">
                  <path
                    d="M8 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm-4 4V5a2 2 0 0 1 2-2h8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div className="footer-link-columns">
          <div className="footer-column">
            <div className="footer-column-title">Quick Links</div>
            <a href="#supply">Operations</a>
            <a href="#catalog">Catalog</a>
            <a href="#network">Network</a>
            <a href="#faq">FAQ</a>
            <a href="#contact">Contact</a>
          </div>
          <div className="footer-column">
            <div className="footer-column-title">Information</div>
            <a href="#contact">Terms of Service</a>
            <a href="#contact">Privacy Policy</a>
            <a href="#contact">Cookies Settings</a>
            <a href="#contact">Shipping Policy</a>
          </div>
        </div>
      </div>
      <div className="footer-divider" aria-hidden="true" />
      <div className="footer-bottom">
        <div className="footer-note">© 2026 FR Fisheries Pvt Ltd. All rights reserved.</div>
        <div className="footer-socials">
          <a href="https://facebook.com" aria-label="Facebook">
            <svg viewBox="0 0 24 24" role="img">
              <path
                d="M14 8h2V5h-2c-2.2 0-4 1.8-4 4v2H8v3h2v6h3v-6h2.3l.7-3H13V9c0-.6.4-1 1-1z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a href="https://twitter.com" aria-label="Twitter">
            <svg viewBox="0 0 24 24" role="img">
              <path
                d="M18.9 7.1c0 .2 0 .4-.1.6-.6 6.2-5.3 9.7-10.6 9.7-2.1 0-4-.6-5.7-1.7h.8c1.7 0 3.3-.6 4.6-1.6-1.6 0-2.9-1.1-3.4-2.6.2.1.5.1.7.1.3 0 .7 0 1-.1-1.7-.4-2.9-1.9-2.9-3.7.5.3 1.1.5 1.7.6-1-.7-1.6-1.8-1.6-3.1 0-.7.2-1.3.5-1.8 1.9 2.3 4.7 3.8 7.9 4-.1-.3-.1-.6-.1-.9 0-2.1 1.7-3.8 3.8-3.8 1.1 0 2.1.5 2.8 1.2.9-.2 1.7-.5 2.4-.9-.3.9-.9 1.6-1.7 2.1.8-.1 1.5-.3 2.2-.6-.5.8-1.1 1.5-1.8 2z"
                fill="currentColor"
              />
            </svg>
          </a>
          <a href="https://instagram.com" aria-label="Instagram">
            <svg viewBox="0 0 24 24" role="img">
              <path
                d="M16.8 3.8H7.2A3.4 3.4 0 0 0 3.8 7.2v9.6a3.4 3.4 0 0 0 3.4 3.4h9.6a3.4 3.4 0 0 0 3.4-3.4V7.2a3.4 3.4 0 0 0-3.4-3.4zm-4.8 4.2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm5.2-.7a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              />
              <circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
            </svg>
          </a>
          <a href="https://linkedin.com" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" role="img">
              <path
                d="M6.5 9H3.8v11.2h2.7V9zm-1.3-1.3A1.6 1.6 0 1 0 5.2 4.6a1.6 1.6 0 0 0 0 3.1zM20.2 20.2h-2.7v-5.6c0-1.3-.5-2.2-1.7-2.2-1 0-1.5.7-1.8 1.4-.1.2-.1.6-.1.9v5.5h-2.7V9h2.7v1.5c.4-.7 1.2-1.7 2.9-1.7 2.1 0 3.7 1.4 3.7 4.3v7.1z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
